import axios from 'axios';

// Envanter bootstrap istemcisi.
// Item kataloğu (tüm silah/zırh/item tanımları, ~320 KB) oyun çalışırken değişmez; ilk istekte
// alınıp bellekte tutulur, sonraki yenilemeler sadece oyuncu verisini ister (catalog=0).
// Katalogda olmayan bir item gelirse (ör. deploy sonrası yeni item) katalog yeniden alınır.

let cachedCatalog = null;
let cachedEfsunConfig = null;

const BASE_ID_KEYS = ['weaponId', 'armorId', 'helmetId', 'bootId', 'earringId', 'necklaceId', 'shieldId', 'potId', 'otherId'];

const catalogCoversInventory = (inventory, catalog) => {
  if (!inventory || !catalog) return false;
  return Object.entries(inventory).every(([type, items]) => {
    if (!Array.isArray(items) || items.length === 0) return true;
    const known = new Set((catalog[type] || []).map((c) => c.id));
    return items.every((invItem) => {
      const key = BASE_ID_KEYS.find((k) => invItem?.[k] != null);
      return !key || known.has(invItem[key]);
    });
  });
};

const remember = (data) => {
  if (data?.catalog && Object.keys(data.catalog).length > 0) cachedCatalog = data.catalog;
  if (data?.efsunConfig) cachedEfsunConfig = data.efsunConfig;
};

export const fetchInventoryBootstrap = async (username) => {
  const base = `/api/inventory/bootstrap?username=${encodeURIComponent(username)}`;
  if (cachedCatalog) {
    const res = await axios.get(`${base}&catalog=0`);
    const data = res.data;
    if (data?.success && catalogCoversInventory(data.inventory, cachedCatalog)) {
      data.catalog = data.catalog || cachedCatalog;
      data.efsunConfig = data.efsunConfig || cachedEfsunConfig;
      return res;
    }
    if (!data?.success) return res;
  }
  const res = await axios.get(base);
  if (res.data?.success) remember(res.data);
  return res;
};

export default fetchInventoryBootstrap;
